import React from 'react';
import { Button } from '@mui/material';
import LoginRoundedIcon from '@mui/icons-material/LoginRounded';

interface LoginPageProps {
  handleSignUp: () => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ handleSignUp }) => (
  <div className="login-page">
    <section className="login-intro" aria-labelledby="login-heading">
      <div className="login-copy">
        <h1 id="login-heading">通院の予定を、<br />もっと身近に。</h1>
        <p>受診する人と、希望の日程を選ぶ。<br />診察の予約依頼から結果の確認まで、<br />Agentがお手伝いします。</p>
        <Button variant="contained" size="large" onClick={handleSignUp} startIcon={<LoginRoundedIcon />}>
          ログインして予約する
        </Button>
        <span className="login-caption">登録済みのアカウントでログインできます。</span>
      </div>
      <svg className="clinic-illustration" viewBox="0 0 400 370" fill="none" aria-hidden="true">
        <path d="M38 132C38 66 99 28 184 28H224C309 28 368 81 368 170V220C368 299 302 342 214 342H163C83 342 38 286 38 220V132Z" fill="#E1F1EF" />
        <path d="M62 304H346" stroke="#B3D1D0" strokeWidth="2" />
        <rect x="101" y="78" width="211" height="232" rx="18" fill="#BED9D7" />
        <rect x="88" y="64" width="211" height="232" rx="18" fill="white" stroke="#CFDFE2" strokeWidth="1.5" />
        <path d="M88 82C88 72.059 96.059 64 106 64H281C290.941 64 299 72.059 299 82V119H88V82Z" fill="#126A73" />
        <path d="M134 51V78M253 51V78" stroke="#183743" strokeWidth="7" strokeLinecap="round" />
        <text x="111" y="102" fill="white" fontSize="13" fontFamily="sans-serif" fontWeight="600">通院の予定</text>
        <rect x="112" y="142" width="43" height="37" rx="7" fill="#F2F7FA" />
        <rect x="172" y="142" width="43" height="37" rx="7" fill="#F2F7FA" />
        <rect x="232" y="142" width="43" height="37" rx="7" fill="#F2F7FA" />
        <rect x="112" y="194" width="43" height="37" rx="7" fill="#F2F7FA" />
        <rect x="172" y="194" width="43" height="37" rx="7" fill="#E1F1EF" />
        <path d="M183 211L191 219L204 205" stroke="#126A73" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="232" y="194" width="43" height="37" rx="7" fill="#F2F7FA" />
        <path d="M113 255H183M113 266H159" stroke="#CCDCE1" strokeWidth="4" strokeLinecap="round" />
        <rect x="211" y="254" width="143" height="63" rx="13" fill="white" stroke="#B9D4D4" strokeWidth="1.5" />
        <rect x="225" y="269" width="30" height="30" rx="9" fill="#E1F1EF" />
        <path d="M240 276V292M232 284H248" stroke="#126A73" strokeWidth="2.5" strokeLinecap="round" />
        <text x="267" y="280" fill="#183743" fontSize="10" fontFamily="sans-serif" fontWeight="600">せきね耳鼻咽喉科</text>
        <text x="267" y="297" fill="#607680" fontSize="9" fontFamily="sans-serif">診察券から、かんたんに</text>
        <circle cx="60" cy="213" r="10" fill="#B1D5CF" />
        <circle cx="338" cy="114" r="7" fill="#B1D5CF" />
      </svg>
    </section>
    <section className="login-details" aria-label="予約のご案内">
      <div><h2>いつもの診察券で予約</h2><p>せきね耳鼻咽喉科の診察券を登録して、受診する人と希望の日程を選べます。</p></div>
      <div><h2>予約の結果を、ひと目で</h2><p>依頼した予約の進み具合や結果は、予約一覧から確認できます。</p></div>
    </section>
  </div>
);

export default LoginPage;
